import React, { createContext, useContext, useEffect, useState } from "react";

const CompareContext = createContext(null);
export const MAX_COMPARE = 3;

export function CompareProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("cc_compare") || "[]");
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem("cc_compare", JSON.stringify(items));
  }, [items]);

  const inCompare = (id) => items.some((i) => i.id === id);

  const toggle = (course) => {
    setItems((prev) => {
      if (prev.some((i) => i.id === course.id)) return prev.filter((i) => i.id !== course.id);
      if (prev.length >= MAX_COMPARE) return prev;
      return [...prev, course];
    });
  };

  const remove = (id) => setItems((prev) => prev.filter((i) => i.id !== id));
  const clear = () => setItems([]);

  return (
    <CompareContext.Provider value={{ items, toggle, remove, clear, inCompare }}>
      {children}
    </CompareContext.Provider>
  );
}

export const useCompare = () => useContext(CompareContext);
